import { TPpdApp } from "../../App/PpdApp";
import { TPpdTaskBase } from "../../App/PpdBaseTask";

export class THomeTask extends TPpdTaskBase {

    /**
     * Při najetí myší přepne CSS třídy dlaždice do aktivního stavu.
     */
    public tileMouseOver(ClientId: string | number): void {
        let _Container = $('#' + ClientId + '_Container')[0];
        let _Caption = $('#' + ClientId + '_Caption')[0];
        let _ContentsWrapper = $('#' + ClientId + '_ContentsWrapper')[0];
        let _Contents = $('#' + ClientId + '_Contents')[0];
        _Container.className = _Container.className.replace('_Normal', '_Active');
        _Caption.className = _Caption.className.replace('_Normal', '_Active');
        _ContentsWrapper.className = _ContentsWrapper.className.replace('_Normal', '_Active');
        _Contents.className = _Contents.className.replace('_Normal', '_Active');
    }

    /**
     * Při opuštění dlaždice myší vrátí CSS třídy do běžného stavu.
     */
    public tileMouseOut(ClientId: string | number): void {
        let _Container = $('#' + ClientId + '_Container')[0];
        let _Caption = $('#' + ClientId + '_Caption')[0];
        let _ContentsWrapper = $('#' + ClientId + '_ContentsWrapper')[0];
        let _Contents = $('#' + ClientId + '_Contents')[0];
        _Container.className = _Container.className.replace('_Active', '_Normal');
        _Caption.className = _Caption.className.replace('_Active', '_Normal');
        _ContentsWrapper.className = _ContentsWrapper.className.replace('_Active', '_Normal');
        _Contents.className = _Contents.className.replace('_Active', '_Normal');
    }

}

ScriptInit(new TPpdApp(), new THomeTask());

document.addEventListener("DOMContentLoaded", () => {
    let successfulLoginInput = document.getElementById('successfulLogin');
    let successfulLoginValue = (successfulLoginInput as HTMLInputElement).value.toLowerCase();
    let isSuccessfulLogin = successfulLoginValue === 'true';
    if (!isSuccessfulLogin) {
        CurrentTask.App.UnsuccessfulLoginError();
    }

    let ribbon = $("#mainRibbon-container .dx-multiview-wrapper").first();
    if (!ribbon.is(":hidden")) {
        (CurrentTask as THomeTask).App.toggleRbn();
    }
});